import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from 'shared/components/LoadingSpinner';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

const StyledDiv = styled.div`
  text-align: center;
  .loading-spinner {
    margin-bottom: ${SPACERS.small};
  }
`;

const ReviewLoading: React.FC = () => {
  return (
    <StyledDiv>
      <LoadingSpinner size={40} className="loading-spinner" />
      <TrueImpactText variant="heading-subheading">
        Checking your report...
      </TrueImpactText>
    </StyledDiv>
  );
};

export default ReviewLoading;
